import { ButtonType } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, LoadingIndicator, useModal } from 'app/components'

/** Cancelar + enviar dos modais da gestão; o envio mostra o carregamento enquanto submete. */
export const RodapeModal = ({
  enviando,
  rotuloEnviar,
  classeEnviar = 'btn-primary',
}: {
  enviando: boolean
  rotuloEnviar: string
  classeEnviar?: string
}) => {
  const { closeModal } = useModal()
  const { t } = useT()
  return (
    <div className='d-flex justify-content-end gap-3 mt-8'>
      <Button
        type={ButtonType.Reset}
        onClick={closeModal}
        className='btn-secondary'
        disabled={enviando}
      >
        {t('common.cancel')}
      </Button>
      <Button type={ButtonType.Submit} className={classeEnviar} disabled={enviando}>
        {enviando ? <LoadingIndicator /> : rotuloEnviar}
      </Button>
    </div>
  )
}
